import React, { memo, ReactNode } from 'react';
import { Chip, Listbox, ListboxItem } from '@heroui/react';
import Label from '../Label';
import SearchboxInput from '../Searchbox-Input';
import { includes } from 'lodash';
import { IPortfolioVesselForm } from '../../portfolioTypes';
import LoadingSpinner from '../../../../shared/components/loading-spinner/LoadingSpinner';

export interface IPortfolioVesselSelectorProps {
	options: IPortfolioVesselForm[];
	selectedKeys?: string[];
	updateSelectedKeys: (keys: string[]) => void;
	applySearchTerm: (searchTerm: string) => void;
	applyScroll: (ref: any) => void;
	children?: ReactNode;
	selectionMode?: 'single' | 'multiple';
	hideSelectedIcon?: boolean;
	title: string;
	listboxRef: React.RefObject<HTMLDivElement | null>;
	isLoading?: boolean;
}

const VesselsSelectbox: React.FC<IPortfolioVesselSelectorProps> = memo(({ ...props }) => {
	const handleSearchTermOnChange = (value: string) => {
		props.applySearchTerm(value);
	};

	return (
		<div className="flex flex-col space-y-2 overflow-y-hidden ">
			<div className="flex-none">
				{' '}
				<Label title={props.title} textSize="sm" />
			</div>
			<SearchboxInput setSearchTerm={handleSearchTermOnChange} />
			{props.children}
			{props.isLoading && props.isLoading === true ? (
				<LoadingSpinner size="sm" label="Loading portfolio vessels" spinnerClassName="flex-auto" />
			) : (
				<Listbox
					items={props.options}
					ref={props.listboxRef} // To scroll to top when new data is loaded
					onScroll={(e) => {
						props.applyScroll(e);
					}} // To trigger scroll event
					aria-label="Listbox"
					className="flex-auto overflow-y-auto border"
					// style={{ scrollbarGutter: 'stable', scrollbarWidth: 'thin' }}
					selectionMode={props.selectionMode}
					hideSelectedIcon={props.hideSelectedIcon}
					selectedKeys={props.selectedKeys}
					onSelectionChange={(keys) => props.updateSelectedKeys(Array.from(keys, String))}
				>
					{props.options.map((item) => (
						<ListboxItem
							key={item.imoNumber}
							classNames={{
								title: 'flex items-center justify-between',
							}}
							textValue={item.toString()}
							className={`rounded h-5 ${includes(Array.from(props.selectedKeys ?? []), item.imoNumber.toString()) ? 'bg-[#D4D4D8]' : null}`}
						>
							<div className="flex-none">
								{item.imoNumber} - {item.vesselName}
							</div>
							<Chip
								className="ml-4 flex-none text-[10px] rounded h-[20px] bg-msi-midblue-color-600 text-msi-white-color"
								size="sm"
							>
								{item.sectorName}
							</Chip>
						</ListboxItem>
					))}
				</Listbox>
			)}
		</div>
	);
});

export default VesselsSelectbox;
